import React from 'react';
import Modal from 'react-modal';

if (typeof document !== 'undefined') {
  const appRoot = document.getElementById('root');
  if (appRoot) {
    Modal.setAppElement('#root');
  } else {
    Modal.setAppElement(document.body);
  }
}

const ModalShell = ({
  isOpen,
  onRequestClose,
  overlayClassName = 'register-modal-overlay',
  className = 'register-modal',
  top = '50%',
  maxWidth = 760,
  maxHeight = 'calc(100vh - 32px)',
  overlayStyle,
  children,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={className}
      overlayClassName={overlayClassName}
      style={{
        content: {
          top,
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          padding: 0,
          border: 'none',
          background: 'transparent',
          transform: 'translate(-50%, -50%)',
          width: 'auto',
          maxWidth,
          maxHeight,
          overflow: 'visible',
          zIndex: 3001,
        },
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 3000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 16,
          ...overlayStyle,
        },
      }}
    >
      {children}
    </Modal>
  );
};

export default ModalShell;
